import { css } from "lit";
import { Style } from "../Styles";

export const styles = css`
    ${Style}
    :host {
        display: block;
        --item-width: 260px;
    }

    ds-media {
        width: 100%;
        height: 100%;
        border-radius: 0.6em;
        cursor: pointer;
    }

    ds-media::part(image) {
        object-fit: cover;
        border-radius: 0.4em;
    }

    ds-media::part(video) {
        object-fit: cover;
        border-radius: 0.4em;
    }

    .media-header {
        position: absolute;
        top: 0;
        left: 0;
        width: var(--item-width);
        background-color: #ffffffaa;
        overflow: hidden;
        cursor: pointer;
        padding: 0.3em;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .media-header span {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow-x: hidden;
    }

    .media-footer {
        position: absolute;
        width: var(--item-width);
        height: 35px;
        bottom: 0;
        left: 0;
        background-color: #ffffffaa;
        overflow: hidden;
        padding: 0.3em;
    }

    .attribute-button {
        position: absolute;
        right: 0.25em;
        bottom: 0.8em;
    }

    .apply-button {
        position: absolute;
        right: 4em;
        bottom: 4em;
    }

    .media-buttons {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        position: absolute;
        width: 100%;
        height: 4em;
        bottom: 0;
        left: 0;
        background-color: var(--accent-color);
        padding: 1em;
    }

    .header {
        display: flex;
        width: 100%;
        justify-content: space-between;
        align-items: center;
        padding: 0.5em;
        justify-content: flex-end;
    }

    @media only screen and (max-width: 1024px) {
        :host {
            --item-width: 220px;
        }
    }

    @media only screen and (max-width: 600px) {
        :host {
            --item-width: 160px;
        }
    }
`;
